import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPromoTypeShown } from 'features/extension_promotion';
import { useLinkDomainData } from 'hooks/analytics_events';
import { useTrackBookingPageShared } from 'hooks/analytics_events/useTrackBookingPageShared';
import { useEventTypeLocation } from 'hooks/useEventTypeLocation';
import { ClipboardButton } from '../clipboard_button';
import { eventTypeSelector } from '../selectors';
const styledClipboardButtonCss = "s103ykpi";
const StyledClipboardButton = forwardRef((props, ref) => {
  const size = 'normal';
  const responsive = false;
  const successStyle = 'success';
  const successMessage = I18n.t('publisher.event_types.context.copied');
  return <ClipboardButton ref={ref} {...props} size={size} responsive={responsive} successStyle={successStyle} successMessage={successMessage} className={classNames(styledClipboardButtonCss, props.className)} />;
});
export const CopyButton = ({
  className,
  ...props
}) => {
  const eventType = useSelector(eventTypeSelector);
  const {
    id: eventTypeId,
    uuid: eventTypeUuid,
    bookingUrl
  } = eventType;
  const dispatch = useDispatch();
  const domainProps = useLinkDomainData(bookingUrl);
  const locationType = useEventTypeLocation(eventType);
  const trackBookingPageShared = useTrackBookingPageShared(eventTypeId);
  const sendBookingPageShared = () => {
    dispatch(setPromoTypeShown('shareEventType'));
    trackBookingPageShared({
      location_type: locationType || null,
      share_object: 'event_type',
      share_object_id: eventTypeId.toString(),
      share_object_uuid: eventTypeUuid,
      share_method: 'copy_link',
      share_location: 'share_modal',
      share_modal_source: 'adhoc_creation',
      is_single_use: false,
      is_customized_at_share: true,
      ...domainProps
    });
  };
  return <StyledClipboardButton size="normal" responsive={false} className={className} content={bookingUrl} onClick={sendBookingPageShared} {...props}>
      {I18n.t('publisher.event_types.context.copy_link')}
    </StyledClipboardButton>;
};

// Export CSS classes for external usage
export { styledClipboardButtonCss };

require("./copy_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./copy_button.js");